import { debounce } from 'lodash-es';
import { IPreferencesV3DataModel, PreferenceScope } from '../../data-models/preferences-v3.data-model';
import { IPreferencesDataModel } from '../../data-models/preferences.data-model';
import { MaggieHttp } from '../MaggieHttp';

export async function getAllPreferences(scope?: PreferenceScope) {
  const { data } = await MaggieHttp.maggie.get<IPreferencesV3DataModel<unknown>[]>(`/preferences/v3/all`, {
    params: {
      scope,
    },
  });

  return data;
}

export async function getOrganizationPreferences() {
  const { data } = await MaggieHttp.maggie.get<IPreferencesV3DataModel<unknown>[]>(`/preferences/v3`, {
    params: {
      scope: PreferenceScope.ORGANIZATION,
    },
  });

  return data;
}

export async function getPreferencesV3(scope: PreferenceScope) {
  const { data } = await MaggieHttp.maggie.get<IPreferencesV3DataModel<unknown>[]>(
    `/preferences/preferenceKey/all`,
    {
      params: {
        scope,
      },
    }
  );

  return data.map((pref) => {
    return { ...pref, scope };
  });
}

export async function updatePreferencesV3<T>(
  payload: Pick<IPreferencesV3DataModel<T>, 'scope' | 'preferenceKey' | 'value'>
) {
  if (!payload.preferenceKey) {
    throw new Error('Module is required');
  }

  const { data } = await MaggieHttp.maggie.put<{ value: T }, IPreferencesV3DataModel<unknown>>(
    `/preferences/v3`,
    { value: payload.value },
    {
      params: {
        scope: payload.scope,
        preferenceKey: payload.preferenceKey,
      },
    }
  );

  return data;
}

export const updatePreferencesDebounced = debounce(updatePreferences, 500);

export async function updatePreferences(payload: IPreferencesDataModel) {
  try {
    return MaggieHttp.maggie.put<IPreferencesDataModel, IPreferencesDataModel>(`/preferences`, payload);
  } catch (err) {
    console.error(err);
  }
}

export async function uploadLogo(formData: FormData) {
  const { data } = await MaggieHttp.maggie.post<FormData, { logoUrl: string }>(
    `/preferences/client-settings/logo`,
    formData
  );
  return data;
}

export async function deletePreferenceV3(
  preference: Pick<IPreferencesV3DataModel<unknown>, 'scope' | 'preferenceKey'>
) {
  const { data } = await MaggieHttp.maggie.delete<IPreferencesV3DataModel<unknown>>(`/preferences/v3`, {
    params: preference,
  });
  return data;
}
